import en from './en';
import vi from './vi';

export default { en, vi };
